import { add, isAfter } from 'date-fns';

/** @param {{daysIDsToApproveOrReject: Map<number, Map<number, Set<number>>>, tableData: import("../../../adapters/weekly-report/get-weekly-report-adapter").TableData}} */
export const isAllChecked = ({ daysIDsToApproveOrReject, tableData }) => {
  if (tableData.length !== daysIDsToApproveOrReject.size) return false;

  const areEquals = tableData.every(({ group }, groupIndex) => {
    const groupMap = daysIDsToApproveOrReject.get(groupIndex);

    if (!groupMap) return false;

    const areEqualsGroup = group.every(({ secondColumn, weeklyReport }, positionLineIndex) => {
      if (secondColumn.isDisabled) return true;
      const positionLineSet = groupMap.get(positionLineIndex);

      if (!positionLineSet) return false;

      const availableDaysCount = weeklyReport.filter(
        (day) => day?.idParteDiario && day?.habilitaCheck
      ).length;

      return positionLineSet.size === availableDaysCount;
    });

    return areEqualsGroup;
  });

  return areEquals;
};

/** @param {{daysIDsToApproveOrReject: Set<number>, group: import('../../../adapters/weekly-report/get-weekly-report-adapter').PositionLine[]}} */
export const isCheckedGroup = ({ daysIDsToApproveOrReject, group, filters }) => {
  const { fechaDesde, fechaHasta } = filters;

  const startDay = add(new Date(fechaDesde), { days: -1 });
  const endDay = add(new Date(fechaHasta), { days: 1 });

  /** @type {number[]} */
  const availableGroupIds = group.reduce((acc, positionLine) => {
    positionLine.weeklyReport.forEach((dayReport) => {
      const isInDateRange =
        isAfter(new Date(dayReport.fecha), startDay) && isAfter(endDay, new Date(dayReport.fecha));

      if (typeof dayReport === 'object' && dayReport.habilitaCheck && isInDateRange) {
        acc.push(dayReport.idParteDiario);
      }
    });

    return acc;
  }, []);

  if (!availableGroupIds.length) return false;

  return availableGroupIds.every((id) => daysIDsToApproveOrReject.has(id));
};

/** @param {{ daysIDsToApproveOrReject: Set<number>, weeklyReport: import('../../../adapters/weekly-report/get-weekly-report-adapter').DailyReport[]}} */
export const isCheckedPosition = ({ daysIDsToApproveOrReject, weeklyReport, filters }) => {
  const { fechaDesde, fechaHasta } = filters;

  const startDay = add(new Date(fechaDesde), { days: -1 });
  const endDay = add(new Date(fechaHasta), { days: 1 });

  // Access the group and position/line of the table data array
  // to retrieve all daily IDs.
  // weeklyReport -> (string | Date)[]
  /** @type {number[]} */
  const weekReportIDs = weeklyReport.reduce((arr, current) => {
    const isInDateRange =
      isAfter(new Date(current.fecha), startDay) && isAfter(endDay, new Date(current.fecha));

    if (typeof current === 'object' && current.habilitaCheck && isInDateRange) {
      arr.push(current.idParteDiario);
    }

    return arr;
  }, []);

  if (weekReportIDs.length === 0) return false;

  return weekReportIDs.every((i) => daysIDsToApproveOrReject.has(i));
};

/** @param {{daysIDsToApproveOrReject: Set<number>, groupIndex: number, lineIndex: number, idParteDiario: number}} */
export const isCheckedDailyReport = ({ daysIDsToApproveOrReject, idParteDiario }) =>
  daysIDsToApproveOrReject.has(idParteDiario);
